import { useContext } from 'react'
import styled from 'styled-components'
import { ExamSubject } from 'generated/graphql'
import DetailInfoTable from '@app.feature/exam/gsat2024-2/components/detailInfoTable/DetailInfoTable'
import { PredictionOfPassedContainerContext } from '@app.feature/exam/gsat2024-2/context/PredictionOfPassedContainerContext'
import { generateTableData } from '@app.feature/exam/gsat2024-2/modules/detailInfoArticleTableData.module'

const DetailInfoArticle = () => {
  const { examGradingResultData } = useContext(
    PredictionOfPassedContainerContext,
  )

  const tableDataList = {
    math: {
      ...(examGradingResultData && {
        ...generateTableData(examGradingResultData, ExamSubject.MATH),
      }),
    },
    reasoning: {
      ...(examGradingResultData && {
        ...generateTableData(examGradingResultData, ExamSubject.REASONING),
      }),
    },
  }

  return (
    <StyledWrapper>
      <DetailInfoTable tableDataList={tableDataList} />
    </StyledWrapper>
  )
}

export default DetailInfoArticle

const StyledWrapper = styled.article`
  padding: 28px;
  border-radius: 10px;
  background-color: #fff;
`
